var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDotMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 5,
    viewBox: "0 0 16 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 0.833008C1.25 0.833008 0.5 1.58301 0.5 2.49967C0.5 3.41634 1.25 4.16634 2.16667 4.16634C3.08333 4.16634 3.83333 3.41634 3.83333 2.49967C3.83333 1.58301 3.08333 0.833008 2.16667 0.833008ZM13.8333 0.833008C12.9167 0.833008 12.1667 1.58301 12.1667 2.49967C12.1667 3.41634 12.9167 4.16634 13.8333 4.16634C14.75 4.16634 15.5 3.41634 15.5 2.49967C15.5 1.58301 14.75 0.833008 13.8333 0.833008ZM8 0.833008C7.08333 0.833008 6.33333 1.58301 6.33333 2.49967C6.33333 3.41634 7.08333 4.16634 8 4.16634C8.91667 4.16634 9.66667 3.41634 9.66667 2.49967C9.66667 1.58301 8.91667 0.833008 8 0.833008Z",
    fill: "#6E7682"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotMenu);
export default __webpack_public_path__ + "static/media/ThreeDotMenu.c404b4bf75739f412e6b9c24b909aaaf.svg";
export { ForwardRef as ReactComponent };